import type analyticsEn from "./analytics.en";

const analyticsAr: Record<keyof typeof analyticsEn, string> = {
  "nav.reports": "التقارير",
  "nav.live_view": "العرض المباشر",
  "an.title": "التحليلات",
  "an.reports": "التقارير",
  "an.live": "العرض المباشر",
  "an.range": "الفترة",
  "an.from": "من",
  "an.to": "إلى",
  "an.preset.today": "اليوم",
  "an.preset.yesterday": "أمس",
  "an.preset.last_7_days": "آخر 7 أيام",
  "an.preset.last_30_days": "آخر 30 يوماً",
  "an.preset.last_90_days": "آخر 90 يوماً",
  "an.preset.this_month": "هذا الشهر",
  "an.preset.last_month": "الشهر الماضي",
  "an.preset.this_year": "هذه السنة",
  "an.preset.custom": "مخصصة",
  "an.compared": "مقارنة بـ {from} – {to}",
  "an.metric.total_sales": "إجمالي المبيعات",
  "an.metric.orders": "الطلبات",
  "an.metric.average_order_value": "متوسط قيمة الطلب",
  "an.metric.sessions": "الجلسات",
  "an.metric.conversion_rate": "معدل التحويل",
  "an.metric.returning_customer_rate": "معدل العملاء العائدين",
  "an.metric.net_sales": "صافي المبيعات",
  "an.metric.returns": "المرتجعات",
  "an.sales_over_time": "إجمالي المبيعات عبر الوقت",
  "an.this_period": "هذه الفترة",
  "an.previous_period": "الفترة السابقة",
  "an.funnel": "مسار التحويل",
  "an.funnel_hint": "الجلسات التي وصلت إلى كل خطوة.",
  "an.funnel.sessions": "الجلسات",
  "an.funnel.added_to_cart": "أضافوا للسلة",
  "an.funnel.reached_checkout": "وصلوا للدفع",
  "an.funnel.converted": "طلبوا",
  "an.top_products": "أفضل المنتجات حسب صافي المبيعات",
  "an.by_channel": "الجلسات حسب القناة",
  "an.by_device": "الجلسات حسب الجهاز",
  "an.by_country": "الجلسات حسب الدولة",
  "an.by_referrer": "أهم المواقع المُحيلة",
  "an.landing_pages": "أهم صفحات الدخول",
  "an.top_searches": "أكثر عمليات البحث",
  "an.marketing": "مبيعات الحملات (UTM)",
  "an.no_data": "لا توجد بيانات لهذه الفترة بعد.",
  "an.no_campaigns": "لا توجد طلبات من روابط حملات بعد.",
  "an.channel.direct": "مباشر",
  "an.channel.organic_search": "محركات البحث",
  "an.channel.paid_search": "بحث مدفوع",
  "an.channel.social": "التواصل الاجتماعي",
  "an.channel.paid_social": "تواصل اجتماعي مدفوع",
  "an.channel.email": "البريد",
  "an.channel.whatsapp": "واتساب",
  "an.channel.sms": "الرسائل النصية",
  "an.channel.referral": "مواقع أخرى",
  "an.channel.draft": "طلبات مسودة",
  "an.channel.api": "واجهة البرمجة",
  "an.channel.pos": "نقطة البيع",
  "an.device.mobile": "الجوال",
  "an.device.desktop": "الكمبيوتر",
  "an.device.tablet": "الجهاز اللوحي",
  "an.device.other": "أخرى",
  "an.speed": "سرعة المتجر",
  "an.speed_hint": "مدى سرعة ظهور صفحاتك للمتسوقين الفعليين (المئين 75).",
  "an.speed_none": "لا توجد زيارات كافية بعد لقياس السرعة.",
  "an.speed_good": "سريع",
  "an.speed_ok": "يحتاج تحسيناً",
  "an.speed_poor": "بطيء",
  "an.speed_samples": "من {n} تحميل صفحة",
  "an.search_reports": "ابحث في التقارير",
  "an.category.sales": "المبيعات",
  "an.category.finance": "المالية",
  "an.category.orders": "الطلبات والتجهيز",
  "an.category.customers": "العملاء",
  "an.category.inventory": "المخزون",
  "an.category.behavior": "السلوك",
  "an.category.marketing": "التسويق",
  "an.group_by": "التجميع حسب",
  "an.group.day": "اليوم",
  "an.group.week": "الأسبوع",
  "an.group.month": "الشهر",
  "an.group.quarter": "الربع",
  "an.group.year": "السنة",
  "an.total": "الإجمالي",
  "an.money_note": "المبالغ بـ {currency}.",
  "an.schedule": "جدولة",
  "an.schedule_title": "إرسال هذا التقرير بالبريد",
  "an.scheduled": "سيُرسل التقرير بالبريد.",
  "an.frequency": "كل كم",
  "an.frequency.daily": "كل يوم",
  "an.frequency.weekly": "كل يوم إثنين",
  "an.frequency.monthly": "أول كل شهر",
  "an.period": "يغطي",
  "an.recipients": "إرسال إلى",
  "an.recipients_hint": "عناوين بريد مفصولة بفواصل. حتى 10.",
  "an.live_hint": "المتسوقون في متجرك خلال آخر 10 دقائق.",
  "an.live.visitors": "الزوار الآن",
  "an.live.carts": "سلال نشطة",
  "an.live.checkout": "في صفحة الدفع",
  "an.live.purchased": "اشتروا",
  "an.live.today": "اليوم حتى الآن",
  "an.live.vs_yesterday": "مقارنة بأمس في الوقت نفسه.",
  "an.live.locations": "أماكنهم",
  "an.live.nobody": "لا أحد في المتجر الآن.",
  "an.live.updated": "آخر تحديث {at}",
  "ce.title": "أحداث العملاء",
  "ce.nav_hint": "البكسلات والتحويلات من الخادم وشريط ملفات تعريف الارتباط",
  "ce.description": "قِس إعلاناتك دون لصق أكواد: أضف معرّفات البكسل، وتُرسل المشتريات أيضاً من الخادم حتى لا تخفيها أدوات حجب الإعلانات.",
  "ce.banner": "شريط ملفات تعريف الارتباط",
  "ce.banner_hint": "تنتظر ملفات التحليل والتسويق الموافقة حيث يظهر الشريط.",
  "ce.banner.regions": "حيث يفرضه القانون",
  "ce.banner.regions_hint": "يظهر لزوار الاتحاد الأوروبي والمملكة المتحدة وسويسرا. لا يُسأل الآخرون.",
  "ce.banner.always": "دائماً",
  "ce.banner.always_hint": "يختار كل زائر قبل تعيين ملفات التحليل أو التسويق.",
  "ce.banner.never": "أبداً",
  "ce.banner.never_hint": "دون شريط. تأكد أن سياسة الخصوصية تغطي ذلك.",
  "ce.pixels": "البكسلات",
  "ce.pixels_hint": "اربط بالمعرّف. تُحمّل البكسلات بعد الموافقة حيث ينطبق الشريط.",
  "ce.on": "مفعّل",
  "ce.off": "متوقف",
  "ce.server_side": "مشتريات من الخادم",
  "ce.sent": "أُرسل {n} شراء خلال آخر 30 يوماً",
  "ce.edit": "تعديل",
  "ce.connect": "ربط",
  "ce.enabled": "مفعّل",
  "ce.docs": "أين تجدها",
  "ce.keep_secret": "محفوظ. اتركه فارغاً للإبقاء عليه.",
  "ce.server_hint": "اختياري. يرسل المشتريات من الخادم أيضاً (دون تكرار مع بكسل المتصفح).",
  "ce.provider.ga4": "Google Analytics 4",
  "ce.provider.ga4_hint": "الزيارات وأحداث التجارة في Google Analytics.",
  "ce.provider.ga4_steps": "في Google Analytics افتح الإدارة › مصادر البيانات › مصدر الويب. انسخ معرّف القياس (G-…). للمشتريات من الخادم أنشئ سر API لبروتوكول القياس في الصفحة نفسها.",
  "ce.provider.google_ads": "إعلانات Google",
  "ce.provider.google_ads_hint": "تحويلات الشراء لحملات إعلانات Google.",
  "ce.provider.google_ads_steps": "في إعلانات Google افتح الأهداف › التحويلات، وأنشئ تحويل شراء للموقع، واختر الإعداد يدوياً وانسخ معرّف التحويل (AW-…) والتسمية.",
  "ce.provider.meta": "Meta (فيسبوك وإنستغرام)",
  "ce.provider.meta_hint": "بكسل Meta وواجهة التحويلات.",
  "ce.provider.meta_steps": "في مدير الأحداث في Meta اختر مجموعة البيانات (البكسل) وانسخ معرّفها. من الإعدادات › واجهة التحويلات أنشئ رمز وصول للمشتريات من الخادم.",
  "ce.provider.tiktok": "تيك توك",
  "ce.provider.tiktok_hint": "بكسل تيك توك وواجهة الأحداث.",
  "ce.provider.tiktok_steps": "في مدير إعلانات تيك توك افتح الأصول › الأحداث › أحداث الويب، واختر البكسل وانسخ معرّفه. أنشئ رمز وصول لواجهة الأحداث من إعداداته.",
  "ce.provider.snapchat": "سناب شات",
  "ce.provider.snapchat_hint": "بكسل سناب وواجهة التحويلات (منتشر في الخليج).",
  "ce.provider.snapchat_steps": "في مدير إعلانات سناب شات افتح مدير الأحداث، وانسخ معرّف بكسل سناب، وأنشئ رمزاً لواجهة التحويلات.",
  "ce.field.measurement_id": "معرّف القياس",
  "ce.field.api_secret": "سر API لبروتوكول القياس",
  "ce.field.conversion_id": "معرّف التحويل",
  "ce.field.conversion_label": "تسمية التحويل",
  "ce.field.pixel_id": "معرّف البكسل",
  "ce.field.test_event_code": "رمز حدث الاختبار",
  "ce.field.access_token": "رمز الوصول",
  "ce.custom": "بكسلات مخصصة",
  "ce.custom_hint": "كود التتبع الخاص بك. يعمل في بيئة معزولة: يستقبل الأحداث القياسية لكنه لا يقرأ صفحات متجرك ولا يغيّرها.",
  "ce.add_pixel": "إضافة بكسل مخصص",
  "ce.no_pixels": "لا توجد بكسلات مخصصة.",
  "ce.pixel_name": "الاسم",
  "ce.code": "الكود",
  "ce.code_hint": "استخدم analytics.subscribe('event_name', (event) => { … }). الأحداث: page_viewed وproduct_viewed وcollection_viewed وsearch_submitted وproduct_added_to_cart وcheckout_started وcheckout_completed وall_events.",
  "ce.delete_pixel": "حذف هذا البكسل؟",
  "ce.delete_pixel_body": "سيتوقف عن العمل في متجرك.",
  "an.report.sales_over_time": "المبيعات عبر الوقت",
  "an.report.sales_by_product": "المبيعات حسب المنتج",
  "an.report.sales_by_variant": "المبيعات حسب الخيار",
  "an.report.sales_by_vendor": "المبيعات حسب المورّد",
  "an.report.sales_by_type": "المبيعات حسب نوع المنتج",
  "an.report.sales_by_collection": "المبيعات حسب المجموعة",
  "an.report.sales_by_discount": "المبيعات حسب رمز الخصم",
  "an.report.sales_by_channel": "المبيعات حسب القناة",
  "an.report.sales_by_customer": "المبيعات حسب العميل",
  "an.report.sales_by_location": "المبيعات حسب الموقع",
  "an.report.sales_by_staff": "المبيعات حسب الموظف (طلبات المسودة)",
  "an.report.sales_by_gateway": "المبيعات حسب طريقة الدفع",
  "an.report.finance_summary": "الملخص المالي",
  "an.report.payments_by_gateway": "المدفوعات حسب الطريقة",
  "an.report.taxes": "الضرائب (ضريبة القيمة المضافة)",
  "an.report.cod_reconciliation": "تسوية الدفع عند الاستلام",
  "an.report.gross_profit": "إجمالي الربح حسب المنتج",
  "an.report.orders_over_time": "الطلبات عبر الوقت",
  "an.report.fulfillment_time": "زمن التجهيز والتوصيل",
  "an.report.delivery_performance": "أداء التوصيل حسب شركة الشحن",
  "an.report.shipping_labels": "ملصقات الشحن",
  "an.report.returns_by_product": "المرتجعات حسب المنتج",
  "an.report.returns_by_reason": "طلبات الإرجاع حسب السبب",
  "an.report.cod_refusals": "رفض الدفع عند الاستلام",
  "an.report.new_vs_returning": "العملاء الجدد والعائدون",
  "an.report.customer_cohorts": "مجموعات العملاء (شهرياً)",
  "an.report.customers_by_location": "العملاء حسب الموقع",
  "an.report.customer_lifetime": "القيمة الدائمة للعميل",
  "an.report.one_time_customers": "عملاء لمرة واحدة",
  "an.report.at_risk_customers": "عملاء معرّضون للفقد",
  "an.report.stock_on_hand": "المخزون المتوفر",
  "an.report.sell_through": "معدل البيع",
  "an.report.abc_analysis": "تحليل ABC",
  "an.report.inventory_valuation": "قيمة المخزون",
  "an.report.low_stock": "مخزون منخفض",
  "an.report.conversion_over_time": "التحويل عبر الوقت",
  "an.report.sessions_by_channel": "الجلسات حسب القناة",
  "an.report.sessions_by_referrer": "الجلسات حسب المُحيل",
  "an.report.sessions_by_utm": "الجلسات حسب الحملة (UTM)",
  "an.report.sessions_by_device": "الجلسات حسب الجهاز",
  "an.report.sessions_by_location": "الجلسات حسب الموقع",
  "an.report.landing_pages": "صفحات الدخول",
  "an.report.top_searches": "أكثر عمليات البحث",
  "an.report.zero_result_searches": "عمليات بحث دون نتائج",
  "an.report.product_views": "مشاهدات المنتجات والمشتريات",
  "an.report.cart_abandonment": "ترك صفحة الدفع",
  "an.report.web_vitals": "سرعة الصفحات (مؤشرات الويب)",
  "an.report.discount_performance": "أداء الخصومات",
  "an.report.marketing_attribution": "إسناد التسويق",
  "an.col.abandoned": "متروكة",
  "an.col.abandonment_rate": "معدل الترك",
  "an.col.added_to_cart": "أضافوا للسلة",
  "an.col.available": "متوفر",
  "an.col.average_order_value": "متوسط قيمة الطلب",
  "an.col.avg_days_to_deliver": "أيام التوصيل",
  "an.col.avg_hours_to_fulfil": "ساعات التجهيز",
  "an.col.cancelled": "ملغاة",
  "an.col.checkouts": "عمليات الدفع",
  "an.col.clicks": "النقرات",
  "an.col.cls": "CLS",
  "an.col.cod_amount": "مبلغ الاستلام",
  "an.col.cod_orders": "طلبات الاستلام",
  "an.col.cod_outstanding": "مبالغ للتحصيل",
  "an.col.cohort": "المجموعة",
  "an.col.collected": "المحصّل",
  "an.col.collection": "المجموعة",
  "an.col.committed": "محجوز",
  "an.col.completed": "مكتملة",
  "an.col.conversion_rate": "معدل التحويل",
  "an.col.converted": "طلبوا",
  "an.col.cost": "التكلفة",
  "an.col.courier": "شركة الشحن",
  "an.col.cumulative_share": "الحصة التراكمية",
  "an.col.customer": "العميل",
  "an.col.customers": "العملاء",
  "an.col.days_of_inventory": "أيام المخزون",
  "an.col.declined": "مرفوضة",
  "an.col.delivered": "تم التوصيل",
  "an.col.delivered_rate": "معدل التوصيل",
  "an.col.discount": "الخصم",
  "an.col.discount_amount": "مبلغ الخصم",
  "an.col.discount_code": "رمز الخصم",
  "an.col.discounts": "الخصومات",
  "an.col.email": "البريد",
  "an.col.failed": "فشلت",
  "an.col.first_order": "أول طلب",
  "an.col.fulfilled_orders": "طلبات مجهّزة",
  "an.col.gift_card_sales": "مبيعات بطاقات الهدايا",
  "an.col.grade": "الفئة",
  "an.col.gross_profit": "إجمالي الربح",
  "an.col.gross_sales": "إجمالي المبيعات",
  "an.col.incoming": "وارد",
  "an.col.inp_ms": "INP (مللي ثانية)",
  "an.col.labels": "الملصقات",
  "an.col.last_order": "آخر طلب",
  "an.col.lcp_ms": "LCP (مللي ثانية)",
  "an.col.location": "الموقع",
  "an.col.margin": "الهامش",
  "an.col.month_1": "الشهر 1",
  "an.col.month_12": "الشهر 12",
  "an.col.month_2": "الشهر 2",
  "an.col.month_3": "الشهر 3",
  "an.col.month_6": "الشهر 6",
  "an.col.net_sales": "صافي المبيعات",
  "an.col.new_customers": "عملاء جدد",
  "an.col.new_customer_sales": "مبيعات العملاء الجدد",
  "an.col.on_hand": "المتوفر",
  "an.col.order_date": "تاريخ الطلب",
  "an.col.orders": "الطلبات",
  "an.col.outstanding": "المستحق",
  "an.col.page_type": "نوع الصفحة",
  "an.col.payment_method": "طريقة الدفع",
  "an.col.period": "الفترة",
  "an.col.product": "المنتج",
  "an.col.rate": "النسبة (%)",
  "an.col.reached_checkout": "وصلوا للدفع",
  "an.col.reason": "السبب",
  "an.col.received": "المستلم",
  "an.col.recovered": "مسترجعة",
  "an.col.refunded": "المسترد",
  "an.col.refusal_rate": "معدل الرفض",
  "an.col.requests": "الطلبات",
  "an.col.results": "النتائج",
  "an.col.returning_customers": "العملاء العائدون",
  "an.col.returning_customer_sales": "مبيعات العملاء العائدين",
  "an.col.return_rate": "معدل الإرجاع",
  "an.col.returns": "المرتجعات",
  "an.col.samples": "تحميلات الصفحات",
  "an.col.search": "البحث",
  "an.col.searches": "عمليات البحث",
  "an.col.sell_through": "معدل البيع",
  "an.col.service": "الخدمة",
  "an.col.sessions": "الجلسات",
  "an.col.share": "الحصة",
  "an.col.shipments": "الشحنات",
  "an.col.shipping": "الشحن",
  "an.col.sku": "SKU",
  "an.col.source_medium_campaign": "المصدر / الوسيط / الحملة",
  "an.col.tax": "الضريبة",
  "an.col.tax_collected": "الضريبة المحصلة",
  "an.col.taxes": "الضرائب",
  "an.col.threshold": "المخزون المنخفض عند",
  "an.col.total_sales": "إجمالي المبيعات",
  "an.col.total_spent": "إجمالي الإنفاق",
  "an.col.ttfb_ms": "TTFB (مللي ثانية)",
  "an.col.unit_cost": "تكلفة الوحدة",
  "an.col.units": "الوحدات",
  "an.col.units_per_order": "وحدات لكل طلب",
  "an.col.units_returned": "وحدات مرتجعة",
  "an.col.units_sold": "وحدات مباعة",
  "an.col.uses": "الاستخدامات",
  "an.col.value": "القيمة",
  "an.col.variant": "الخيار",
  "an.col.views": "المشاهدات",
  "an.col.view_to_order": "من المشاهدة للطلب",
  "an.col.visitors": "الزوار",
  "an.col.weight_kg": "الوزن (كغ)",
  "an.col.channel": "القناة",
  "an.col.device": "الجهاز",
  "an.col.landing_page": "صفحة الدخول",
  "an.col.product_type": "نوع المنتج",
  "an.col.referrer": "المُحيل",
  "an.col.staff": "الموظف",
  "an.col.utm": "الحملة (UTM)",
  "an.col.vendor": "المورّد",
};

export default analyticsAr;
